import { UnitedEffect } from 'game/extended/heros/paladin/united/united_effect'

export default {
    events: {},
    effects: {
        UnitedEffect
    },
    requirements: {}
}